import type { ButtonHTMLAttributes } from "react";
import s from "./Button.module.css";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "text";
}

const VARIANT_CLASS: Record<"secondary" | "text", string> = {
  secondary: s.secondary,
  text: s.text,
};

export function Button({ variant = "primary", className, children, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={
        variant === "primary" ? className : `${VARIANT_CLASS[variant]} ${className ?? ""}`.trim()
      }
      {...rest}
    >
      {children}
    </button>
  );
}
